import {
  SET_LIST,
  CHANGE_GROUP,
  SET_DEPT,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
  SET_SORT,
  SET_ORDER,
  CLEAR,
} from "./mutation-types";

export default {
  [SET_LIST](state, listItems) {
    state["groups"] = [...listItems];
  },
  [CHANGE_GROUP](state, payload) {
    const groups = state["groups"];
    groups.splice(payload.index, 1, payload.newGrp);
  },
  [SET_TOTAL](state, total) {
    state["total"] = total;
  },
  [SET_DEPT](state, dept) {
    state["dept"] = dept;
  },
  [SET_OFFSET](state, offset) {
    state["offset"] = offset;
  },
  [SET_MAX](state, max) {
    state["max"] = max;
  },
  [SET_SORT](state, sort) {
    state["sort"] = sort;
  },
  [SET_ORDER](state, order) {
    state["order"] = order;
  },
  [CLEAR](state) {
    state["groups"] = [];
    state["total"] = 0;
    state["max"] = 10;
    state["offset"] = 0;
    state["sort"] = "id";
    state["order"] = "ascending";
  },
};
